module.exports = __webpack_public_path__ + "img/presetImg16-9.e477e3cf.png";